import { useAuthentication } from '@connected/api-client/hooks/use-authentication';
import { SidebarProvider, SidebarTrigger } from '@connected/ui/components/sidebar';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardSidebar } from '@/components/dashboard-sidebar';

export const Route = createFileRoute('/_auth/dashboard')({
    component: RouteComponent,
});

function RouteComponent() {
    const { currentUser } = useAuthentication();
    const navigate = Route.useNavigate();

    if (!currentUser) {
        navigate({
            to: '/customer',
        });
    }

    return (
        <SidebarProvider>
            <div className="flex w-full h-full">
                <DashboardSidebar />
                <div className="flex-1 min-w-0 md:p-8 p-4">
                    <SidebarTrigger className="md:hidden mb-4" />
                    <Outlet />
                </div>
            </div>
        </SidebarProvider>
    );
}
